const isMacAgent = navigator.userAgent.indexOf('Mac OS X') !== -1;

const KEYBOARD = {
  SHORTCUT: {
    COMMAND: isMacAgent ? 'Cmd' : 'Control',
    SHIFT: 'Shift',
    ALT: 'Alt',
    PERIOD: '.',
    COMMA: ',',
    PLUS: '+',
  },
} as const;

export { KEYBOARD };
